export * from "./dashboard-text-config";
export * from "./links-config";
export * from "./main-text-config";
export * from "./onboarding-text-config";
